module.exports = __webpack_public_path__ + "img/productionBaseR_1.5c0f502c.png";